import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from './service';
import OpService from '../operation/service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});


export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_REPORTS = 'UPDATE_REPORTS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_EMPLOYEES = 'UPDATE_EMPLOYEES';
export const initModuleAction = 'initModuleAction';
export const updatePreReportsAction = 'updatePreReportsAction';
export const editPreReportAction = 'editPreReportAction';

export default {
  namespaced: true,
  state: {
    searchingReports: false,
    report: {
      pr_comercial: '',
      pr_juridico: '',
      pr_financiero: '',
      pr_final: '',
      id: '',
    },
    error: '',
    employees: [],
    operation: {},
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'report', {
        pr_comercial: '',
        pr_juridico: '',
        pr_financiero: '',
        pr_final: '',
        id: '',
      });
      Vue.set(state, 'error', '');
      Vue.set(state, 'employees', []);
      Vue.set(state, 'operation', {});
    },
    [UPDATE_ERROR](state, msg) {
      Vue.set(state, 'error', msg);
    },
    [UPDATE_REPORTS](state, payload) {
      Vue.set(state, 'report', payload);
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [UPDATE_EMPLOYEES](state, payload) {
      payload.forEach((e) => {
        state.employees.push(e.attributes.title);
      });
    },
  },
  actions: {
    [initModuleAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'tabpropuesta');
      commit(CLEAR_MODULE);
      commit(UPDATE_OPERATION, payload.operation);
      commit(UPDATE_EMPLOYEES, []);
      return Service.getEmployees()
        .then((res) => {
          commit(UPDATE_EMPLOYEES, res.data.data);
          Service.getReportByOperationId(payload.operation.id)
            .then((data) => {
              commit(UPDATE_REPORTS, data);
              endLoading(dispatch, 'tabpropuesta');
            });
        });
    },
    [updatePreReportsAction]({ commit, state, rootGetters }, payload) {
      let preReportData = {};
      let promise = null;
      const denegada = payload.status.filter(e => e.text === 'Denegada');
      const preAprobada = payload.status.filter(e => e.text === 'Pre-aprobada');
      const condicionada = payload.status.filter(e => e.text === 'Condicionada');
      let msg = '';
      const timeStamp = Math.floor(Date.now() / 1000);
      let today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      today = `${dd}/${mm}/${yyyy}`;
      switch (payload.$event.title) {
        case 'Analista Comercial':
          if (state.report.pr_comercial && state.report.pr_comercial.length) {
            msg = `${state.report.pr_comercial}\n`;
          }
          break;
        case 'Analista Juridico':
          if (state.report.pr_juridico && state.report.pr_juridico.length) {
            msg = `${state.report.pr_juridico}\n`;
          }
          break;
        case 'Responsable Financiero':
          if (state.report.pr_financiero && state.report.pr_financiero.length) {
            msg = `${state.report.pr_financiero}\n`;
          }
          if (payload.$event.option === 'Aprobado' || payload.$event.model.option === 'Aprobado') {
            OpService.updateOperation({ id: rootGetters.getOpid, state: preAprobada[0].value, preApproval: timeStamp })
            .then(newData => commit(UPDATE_OPERATION, newData));
          }
          break;
        default:
          msg = '';
      }

      if (payload.$event.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Denegado') {
        OpService.updateOperation({ id: rootGetters.getOpid, state: denegada[0].value })
        .then(newData => commit(UPDATE_OPERATION, newData));
        msg += `[${today} - ${payload.user} en nombre de ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Denegado') {
        OpService.updateOperation({ id: rootGetters.getOpid, state: denegada[0].value })
        .then(newData => commit(UPDATE_OPERATION, newData));
        msg += `[${today} - ${payload.user} en nombre de ${payload.$event.model.user}] ${payload.$event.model.option}\n
        ${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Condicionado') {
        OpService.updateOperation({ id: rootGetters.getOpid, state: condicionada[0].value })
        .then(newData => commit(UPDATE_OPERATION, newData));
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Condicionado') {
        OpService.updateOperation({ id: rootGetters.getOpid, state: condicionada[0].value })
        .then(newData => commit(UPDATE_OPERATION, newData));
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      }
      if (payload.$event.title === 'Analista Comercial') {
        preReportData = {
          pr_comercial: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Analista Juridico') {
        preReportData = {
          pr_juridico: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Responsable Financiero') {
        preReportData = {
          pr_financiero: msg,
          id: payload.id,
        };
      }
      promise = Service.updatePreReport(preReportData);
      return promise
        .then(newData => commit(UPDATE_REPORTS, newData));
    },
  },
  getters: {
    employees: state => state.employees,
    preReport: state => state.report,
    operationUpdated: state => state.operation,
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-propuesta/store.js